export const APP_BASE_PATH = '/grand-est-2027';

export const getAppPath = (path) => `${APP_BASE_PATH}${path}`;
